<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container" :style="{height: contentHeight}">
        <div class="modal_header">
          <div>
            {{ title }}
          </div>
        </div>
        <div class="modal_body" :style="{height: modalHeight}">
          <div class="body">
            <div class="init_modal_text" v-html="question"></div>
            <div class="newPassword" v-if="flag">
              <div class="label">
                {{ newPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="newPassword"
                v-model="newPasswordInput"
              />
            </div>
            <div class="confirmPassword" v-if="flag">
              <div class="label">
                {{ confirmPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="confirmPassword"
                v-model="confirmPasswordInput"
              />
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="changeButton"
              class="finish_button"
              @click="matching"
            />
          </div>
          <div class="modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="StayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from './loadingModalWindow.vue'

export default {
  props: ['question', 'flag'],
  data() {
    return {
      title: '初期パスワード設定',
      newPassword: '新しいパスワード :',
      newPasswordInput: '',
      confirmPassword: '新しいパスワードの確認 :',
      confirmPasswordInput: '',
      changeWord: 'パスワードを変更しますか？',
      completeWord: '',
      failureWord: '',
      cancelButton: 'キャンセル',
      changeButton: 'OK',
      showFailureModal: false,
      showCompleteModal: false,
      showloadingModal: false
    }
  },
  components: {
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    backgroundColor() {
      if (this.showCompleteModal === true || this.showFailureModal === true) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    contentHeight() {
      if (this.flag) {
        return '395px'
      } else {
        return '230px'
      }
    },
    modalHeight() {
      if (this.flag) {
        return '347px'
      } else {
        return '182px'
      }
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    StayClose(e) {
      this.showFailureModal = false
    },
    async matching(e) {
      this.showloadingModal = true
      if (this.flag) {
        var newPassword = this.newPasswordInput
        var confirmPassword = this.confirmPasswordInput
        if (newPassword === '' || confirmPassword === '') {
          this.failureWord =
            this.errorMsg.MSGCRC0095.name + this.errorMsg.MSGCRC0095.value
          this.showFailureModal = true
        } else if (newPassword !== confirmPassword) {
          this.failureWord =
            this.errorMsg.MSGCRC0090.name + this.errorMsg.MSGCRC0090.value
          this.showFailureModal = true
        } else {
          // パスワード更新のコードを追記
          try {
            await this.$store.dispatch(
              'masters/updatePasswordEnableFlagMaster',
              {flag: true, newPassword}
            )
            this.completeWord = 'アプリパスワード使用設定を変更しました。'
            this.showCompleteModal = true
          } catch (error) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_430006
            let eventType = 3
            let reason = ''
            if (
              error.response &&
              error.response.data &&
              error.response.data.header &&
              error.response.data.header.message
            ) {
              let errorMessage = error.response.data.header.message
              if (errorMessage === 'MSGCRC0091') {
                this.failureWord =
                  this.errorMsg.MSGCRC0091.name +
                  this.errorMsg.MSGCRC0091.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0095') {
                this.failureWord =
                  this.errorMsg.MSGCRC0095.name +
                  this.errorMsg.MSGCRC0095.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0197') {
                this.failureWord =
                  this.errorMsg.MSGCRC0197.name +
                  this.errorMsg.MSGCRC0197.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0125') {
                this.failureWord =
                  this.errorMsg.MSGCRC0125.name +
                  this.errorMsg.MSGCRC0125.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0135') {
                this.failureWord =
                  this.errorMsg.MSGCRC0135.name +
                  this.errorMsg.MSGCRC0135.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0136') {
                this.failureWord =
                  this.errorMsg.MSGCRC0136.name +
                  this.errorMsg.MSGCRC0136.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else {
                this.failureWord =
                  this.errorMsg.MSGCRC0134.name +
                  this.errorMsg.MSGCRC0134.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              }
              reason = errorMessage + ' '
              reason += error.response.status
            } else {
              reason = 'MSGCRC0005'
              eventType = 9
              this.failureWord =
                this.errorMsg.MSGCRC0005.name +
                this.errorMsg.MSGCRC0005.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.showFailureModal = true
          }
        }
      } else {
        try {
          await this.$store.dispatch('masters/updatePasswordEnableFlagMaster', {
            flag: false
          })
          this.completeWord = 'アプリパスワード使用設定を変更しました。'
          this.showCompleteModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_430007
          let eventType = 3
          let reason = ''
          if (
            error.response &&
            error.response.data &&
            error.response.data.header &&
            error.response.data.header.message
          ) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0136') {
              this.failureWord =
                this.errorMsg.MSGCRC0136.name +
                this.errorMsg.MSGCRC0136.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0134.name +
                this.errorMsg.MSGCRC0134.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.failureWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showFailureModal = true
        }
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  width: 435px;
}
.modal_header {
  display: table;
  width: 100%;
}
.modal_header div {
  padding-left: 14px;
  display: table-cell;
  vertical-align: middle;
}
.body {
  height: 262px;
  padding-top: 40px;
}
.require_items_label {
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/changeInitLoginPasswordModalWindow.vue